export const ZeroMatchingUnitEnum = {
  typeId: 118,
};
